import storageService from "@/services/storage.service";
import { initKeycloakAuth } from "@/composables/keycloak-auth.composable";
import { hasKeycloakConfig, keycloakLogin } from "@/lib/keycloak";
import {
    isSkipAutoKeycloakLoginPending,
    setPostLoginRedirect,
} from "@/services/keycloak.service";
import { isAccountBannedSession } from "@/helpers/accountBannedSession";
import { isAccountDeletedSession } from "@/helpers/accountDeletedSession";
import {
    requiresProfileOnboarding,
    PROFILE_ONBOARDING_ALLOWED_ROUTE_NAMES,
} from "@/helpers/profileOnboarding";

const routerGuard = (router: any) =>
{
    router.beforeEach((to: any, from: any, next: any) =>
    {
        if (isAccountBannedSession()) {
            if (to.name !== "accountBanned") {
                next({ name: "accountBanned", replace: true });
            } else {
                next();
            }
            return;
        }
        if (isAccountDeletedSession()) {
            if (to.name !== "accountDeleted") {
                next({ name: "accountDeleted", replace: true });
            } else {
                next();
            }
            return;
        }
        if (
            hasKeycloakConfig() &&
            to.name !== "accountBanned" &&
            to.name !== "accountDeleted" &&
            !isSkipAutoKeycloakLoginPending()
        ) {
            initKeycloakAuth().catch(() => {
            });
        }
        const token = storageService.getToken();
        const user = storageService.getUser();
        if (
            token &&
            requiresProfileOnboarding(user) &&
            to.name &&
            !PROFILE_ONBOARDING_ALLOWED_ROUTE_NAMES.has(to.name)
        ) {
            next({ name: "createProfile", replace: true });
            return;
        }
        if (to.matched.some((record: any) => record.meta.authScreen))
        {
            if (!token)
            {
                next()
                return true;
            }
            next(false);
            return false;
        } else if (to.matched.some((record: any) => record.meta.requiresAuth))
        {
            if (token)
            {
                next()
                return true;
            }
            if (hasKeycloakConfig()) {
                setPostLoginRedirect(to.fullPath);
                keycloakLogin().catch(() => {
                    // ignore; fall back to local route
                });
                next(false);
                return false;
            }
            next('/signin')
            return false;
        }
        next()
    })
}

export default routerGuard;